module.exports = __webpack_public_path__ + "assets/img/webTips.ff3350a8.png";